import React, { Component } from 'react'
import ky from 'lib/ky'
import Current from 'frontend/lib/current'
import ScheduleSlot from 'frontend/schedule/schedule-slot'
import ActionModal from 'frontend/components/action-modal'
import PropTypes from 'prop-types'
import ScheduleBase from 'frontend/schedule/schedule-base'

export default class RoomsSuggestionsModal extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  async updateSuggestions (props) {
    this.setState({ suggestions: null })
    const suggestions = await ky(
      `/${Current.cityId}/locations/${props.location.id}/schedule.json`, {
        searchParams: {
          dateFrom: props.time.format('YYYY-MM-DD'),
          aroundHour: props.time.hour(),
          availableOnly: '1'
        }
      }
    ).json()

    // drop rooms without slots
    suggestions.rooms = suggestions.rooms.filter((room) => {
      return (
        (props.excludeRooms || []).findIndex((otherRoom) => otherRoom.id === room.id) === -1 &&
        room.dates[0] &&
        room.dates[0].timeSlots[0]
      )
    })

    ScheduleBase.processRooms(suggestions.rooms)
    this.setState({ suggestions })
  }

  componentDidMount () {
    this.updateSuggestions(this.props)
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.updateSuggestions(this.props)
    }
  }

  handleSlotSelect (args = {}) {
    this.setState({
      selectedSlot: args.timeSlot,
      selectedRoom: args.timeSlot.room,
      selectedTime: args.timeSlot.time
    })

    this.props.onSelect(args)
  }

  renderCountNotMatchMessage (room) {
    if (room.minPlayers >= this.props.playersCount) {
      return <div className="players-count-message">(Min {room.minPlayers} players)</div>
    } else if (room.maxPlayers <= this.props.playersCount) {
      return <div className="players-count-message">(Max {room.maxPlayers} players)</div>
    } else {
      return null
    }
  }

  renderTimeSlots (room, countMatch) {
    return room.dates[0].timeSlots.map(
      function (timeSlot) {
        if (!this.props.selectedTime || this.props.time.hour() === timeSlot.time.hour()) {
          return (
            <ScheduleSlot
              key={timeSlot.time}
              timeSlot={timeSlot}
              room={room}
              schedule={this.state.suggestions}
              selectedRoom={this.state.selectedRoom}
              selectedTime={this.state.selectedTime}
              playersCount={this.props.playersCount}
              cartItems={this.props.cartItems}
              onSelect={this.handleSlotSelect.bind(this)}
              disabled={!countMatch}
              onPlayersCountSelect={this.props.onPlayersCountSelect}
            />
          )
        }
      }.bind(this)
    )
  }

  renderRoom (room) {
    if (room.pageOpened) {
      return (
        <div className="bage">
          <a href={room.path}>
            {room.image && <img className="image" src={room.image.xsmallSquare} />}
            <span className="name">{room.name}</span>
          </a>
        </div>
      )
    } else {
      return (
        <div className="bage">
          {room.image && <img className="image" src={room.image.xsmallSquare} />}
          <span className="name">{room.name}</span>
        </div>
      )
    }
  }

  renderTitle () {
    if (this.state.suggestions && this.state.suggestions.rooms.length > 0) {
      return (
        <span>
          Rooms available at&nbsp;
          <span className="location-name">{this.state.suggestions.name}</span>&nbsp; Location
          during selected time
        </span>
      )
    } else if (this.state.suggestions) {
      return (
        <span>
          No rooms available at&nbsp;
          <span className="location-name">{this.state.suggestions.name}</span>&nbsp; location
          during selected time.
        </span>
      )
    }

    return null
  }

  renderRooms () {
    return this.state.suggestions.rooms.map(
      function (room) {
        const countMatch = this.props.playersCount
          ? room.minPlayers <= this.props.playersCount &&
            room.maxPlayers >= this.props.playersCount
          : true
        return (
          <div className={`room room-${room.id}`} key={room.id}>
            {this.renderRoom(room)}
            {this.renderTimeSlots(room, countMatch)}
            {countMatch ? null : this.renderCountNotMatchMessage(room)}
          </div>
        )
      }.bind(this)
    )
  }

  renderSuggestions () {
    if (this.state.suggestions && this.state.suggestions.rooms.length > 0) {
      return (
        <div className="container">
          <div className="rooms">{this.renderRooms()}</div>
        </div>
      )
    } else if (this.state.suggestions) {
      return null
    }

    return (
      <div className="container">
        <div className="loading">
          <div className="spinner"></div>Loading...
        </div>
      </div>
    )
  }

  render () {
    return (
      <ActionModal
        title={this.renderTitle()}
        body={this.renderSuggestions()}
        onClose={this.props.onClose}
        isOpen={this.props.isOpen}
        className="rooms_suggestions_modal"
      />
    )
  }
}

RoomsSuggestionsModal.propTypes = {
  location: PropTypes.object.isRequired,
  excludeRooms: PropTypes.array,
  time: PropTypes.object.isRequired,
  playersCount: PropTypes.number,
  onSelect: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onPlayersCountSelect: PropTypes.func,
  cartItems: PropTypes.object,
  selectedTime: PropTypes.object
}
